
import {render} from "./methods/render.js";

import {createOpenOnClickDivs} from "./methods/createOpenOnClickDivs.js";

import {getOpenOnClickDivs} from "./methods/getOpenOnClickDivs.js";


export class SmetioSideMenuItem{
    
    constructor(){
    
        this.id = "";
        
        this.extraClass = "";
        
        this.tab_toggle_id = "";
        
        this.openOnClick_divs = "";
        
        this.openOnClick_preloader = "";

        this.text = "";
        
        this.text_extra_attributes = "";
        
        this.isActive = "";
        
        this.icon = "";
        
        this.textToken = "";
      
        this.render = render;
        
        this.createOpenOnClickDivs = createOpenOnClickDivs;
        
        this.getOpenOnClickDivs = getOpenOnClickDivs;
               
    };

}
